
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import { formatDate } from "@/utils";
import * as modals from "@/lib/modals";

@Component({
  name: modals.restoreManifestModal
})
export default class RestoreManifestModal extends Mixins(mixin) {
  manifestModule: ManifestModule = getModule(ManifestModule);

  async restore() {
    this.isLoading = true;
    for (let index = 0; index < this.selectedItems.length; index++) {
      let manifest = this.selectedItems[index];

      try {
        await this.manifestModule.restoreManifest(manifest);
        this.addActionResult({
          number: manifest.id,
          success: true,
          message: `Manifest ${manifest.manifestName} successfully restored.`
        });
      } catch (error) {
        this.addActionResult({
          number: manifest.id,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshManifests();
    this.hideModal();
  }

  async refreshManifests(){
    await this.manifestModule.updateManifestsAfterAction(this.selectedItems);
  }

  formatDate(value){
    return formatDate(value);
  }
}
